import { redirect } from "react-router"
import { consumeLoginReturnTo } from "../../utils/loginReturnTo"

export async function loader() {
  const { authPayload } = await window.domain.GetAuthPayloadAuthUseCase.execute()

  if (authPayload) {
    return redirect(consumeLoginReturnTo())
  }

  return null
}
